export default "__VITE_ASSET__3eae32ea__"